import PropTypes from 'prop-types';

import FormStepModal from '#client/components/FormStepModal';

import Content from './Content';

export default function AstraAuthorizationModal({ handleClose, actionsKit }) {
  const resetSearchParameters = () => {
    if (typeof actionsKit?.resetSearchParameters === 'function') {
      actionsKit.resetSearchParameters();
    }
  };

  const handleCloseAndResetSearchParams = () => {
    handleClose();
    resetSearchParameters();
  };

  return (
    <FormStepModal
      disableBack={false}
      handleBack={handleClose}
      handleClose={handleCloseAndResetSearchParams}
      title="Instant deposit"
    >
      <Content handleClose={handleClose} />
    </FormStepModal>
  );
}

AstraAuthorizationModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  actionsKit: PropTypes.shape({
    resetSearchParameters: PropTypes.func
  })
};
